class AvailValidate {

    constructor(data) {
        this.data = data
    }
    validate() {
        const typeValidate = this.availType(this.data)
        const destinationsValidate = this.destinationsValidate(this.data)
        const flightDataValidate = this.flightDataValidate(this.data)
        const providerValidate = this.providerValidate(this.data)
        const paxesValidate = this.paxesValidate(this.data)

        // console.log('paxesValidate', paxesValidate)

        const errors = [
            ...typeValidate, 
            ...destinationsValidate,
            ...flightDataValidate,
            ...providerValidate,
            ...paxesValidate
        ]

        return {
            status: !errors.length ? false : true,
            errors: errors
        }
    }
    
    availType(data) {
        const errors = [];
        if (typeof data.serviceType !== 'string') {
            errors.push({ key: 'serviceType', message: 'serviceType must be a string' });
        }
        if (!Array.isArray(data.destinations)) {
            errors.push({ key: 'destinations', message: 'destinations must be an array' });
        } else {
            data.destinations.forEach((destination, index) => {
                if (typeof destination.origin.id !== 'string') {
                    errors.push({ 
                        key: `destinations.${index}.origin.id`,
                        message: 'origin.id must be a string',
                        index: index
                    });
                }
                if (typeof destination.origin.type !== 'string') {
                    errors.push({ 
                        key: `destinations.${index}.origin.type`, 
                        message: 'origin.type must be a string',
                        index: index 
                    });
                }
                if (typeof destination.destiny.id !== 'string') {
                    errors.push({ 
                        key: `destinations.${index}.destiny.id`, 
                        message: 'destiny.id must be a string',
                        index: index
                    });
                }
                if (typeof destination.destiny.type !== 'string') {
                    errors.push({ 
                        key: `destinations.${index}.destiny.type`, 
                        message: 'destiny.type must be a string',
                        index: index
                    });
                }
                if (typeof destination.start !== 'string') {
                    errors.push({ 
                        key: `destinations.${index}.start`, 
                        message: 'start must be a string',
                        index: index
                    });
                }
                if (typeof destination.end !== 'string' && data.serviceType === 'round-trip') {
                    errors.push({ 
                        key: `destinations.${index}.end`, 
                        message: 'end must be a string',
                        index: index
                    });
                }
            });
        }
        if (typeof data.showOnlyNonStopFlight !== 'boolean') {
            errors.push({ key: 'showOnlyNonStopFlight', message: 'showOnlyNonStopFlight must be a boolean' });
        }
        if (typeof data.flightClass !== 'string') {
            errors.push({ key: 'flightClass', message: 'flightClass must be a string' });
        }
        if (typeof data.culture !== 'string') {
            errors.push({ key: 'culture', message: 'culture must be a string' });
        }
        if (typeof data.currency !== 'string') {
            errors.push({ key: 'currency', message: 'currency must be a string' });
        }
        /*if (typeof data.start !== 'string') {
            errors.push({ key: 'start', message: 'start must be a string' });
        }
        if (typeof data.end !== 'string') {
            errors.push({ key: 'end', message: 'end must be a string' });
        }*/
        if (typeof data.paxes !== 'object') {
            errors.push({ key: 'paxes', message: 'paxes must be an object' });
        } else {
            if (!Array.isArray(data.paxes.adults)) {
                errors.push({ key: 'paxes.adults', message: 'paxes.adults must be an array' });
            }
            if (!Array.isArray(data.paxes.children)) {
                errors.push({ key: 'paxes.children', message: 'paxes.children must be an array' });
            }
        }
       
        return errors;
    }
    paxesValidate(data) {
        const errors = [];
        
        if (typeof data.paxes === 'object') {
            if (Array.isArray(data.paxes.adults)) {
                data.paxes.adults.forEach((adult, index)=> {
                    if(typeof adult !== 'number') {
                        errors.push({ 
                            key: `paxes.${index}.adults`, 
                            message: 'paxes.adults must be an number',
                            index: index
                        });
                    }
                })
            }
            if (Array.isArray(data.paxes.children)) {
                data.paxes.children.forEach((children, index)=> {
                    if(typeof children !== 'number') {
                        errors.push({ 
                            key: `paxes.${index}.children`, 
                            message: 'paxes.children must be an number',
                            index: index
                        });
                    }
                })
            }
        }
       
        return errors;
    }
    flightDataValidate(data) {
        const errors = [];
        if (!data.serviceType) {
            errors.push({ key: 'serviceType', message: 'serviceType is required' });
        }
        
        if (!data.flightClass) {
            errors.push({ key: 'flightClass', message: 'flightClass is required' });
        }
        if (!data.culture) {
            errors.push({ key: 'culture', message: 'culture is required' });
        }
        if (!data.currency) {
            errors.push({ key: 'currency', message: 'currency is required' });
        }
        /*if (!data.start) {
            errors.push({ key: 'start', message: 'start is required' });
        }
        if (!data.end) {
            errors.push({ key: 'end', message: 'end is required' });
        }*/
       
        return errors;
    }
     providerValidate(data) {
        const errors = [];
        if (!data.providers.length) {
            errors.push({ key: 'provider_id', message: 'provider_id is required' });
        }
        return errors;
    }
    
    destinationsValidate(data) {
        const errors = [];
        
        if (Array.isArray(data.destinations))  {
            data.destinations.forEach((destination, index) => {
                if ( !destination.origin.id ) {
                    errors.push({ 
                        key: `destinations.${index}.origin.id`,
                        message: 'origin.id is required',
                        index: index
                    });
                }
                if ( !destination.origin.type) {
                    errors.push({ 
                        key: `destinations.${index}.origin.type`, 
                        message: 'origin.type is required',
                        index: index 
                    });
                }
                if ( !destination.destiny.id) {
                    errors.push({ 
                        key: `destinations.${index}.destiny.id`, 
                        message: 'destiny.id is required',
                        index: index
                    });
                }
                if ( !destination.destiny.type) {
                    errors.push({ 
                        key: `destinations.${index}.destiny.type`, 
                        message: 'destiny.type is required',
                        index: index
                    });
                }
                if ( !destination.start) {
                    errors.push({ 
                        key: `destinations.${index}.start`, 
                        message: 'start is required',
                        index: index
                    });
                }
                if ( !destination.end && data.serviceType === 'round-trip') {
                    errors.push({ 
                        key: `destinations.${index}.end`, 
                        message: 'end is required',
                        index: index
                    });
                }
            });
        }
        
       
        return errors;
    }
}

export default AvailValidate

